import * as React from 'react';

import { DefaultImage, UserImage } from './ProfileImage.styled';
import { ProfileImageError } from 'kb-shared';

type Props = {
  profileImage?: string;
  error: ProfileImageError | null;
  size?: number;
  onError: () => void;
};

export const ProfileImage = (props: Props) => {
  const { profileImage, onError, size, error } = props;

  if (!profileImage || error) return <DefaultImage size={size} />;

  return <UserImage src={profileImage} alt="Profile photo" onError={onError} size={size} />;
};
